import styles from './menu-button.module.scss';

const MenuButton = ({ isOpen, toggle }) => {
    return (
        <button className={styles.menuButton} onClick={toggle} aria-label='Toggle menu'>
            <div className={`${styles.bar} ${isOpen ? styles.topOpen : ''}`} />
            <div className={`${styles.bar} ${isOpen ? styles.middleOpen : ''}`} />
            <div className={`${styles.bar} ${isOpen ? styles.bottomOpen : ''}`} />
        </button>
    );
};

export default MenuButton;
